import React from 'react';
import redraft from 'redraft';
import { DRAFTJS_V0 } from '../../../../config/draftJs';
import ViewerErrorBoundary from '../common/ViewerConclusion/ViewerErrorBoundary';
import { Textiles } from './index.style';
import useRichTextRenderers from './useRichTextRenderers';
export const RICH_TEXT_ERROR_TEXT = 'There was an error while rendering this component.';
const RichTextViewer = ({ componentValues, VideoComponent, CodeComponent, LabComponent, QuestionComponent, LinkComponent, ImageComponent }) => {
    const { body } = componentValues !== null && componentValues !== void 0 ? componentValues : {};
    const { type, val } = body !== null && body !== void 0 ? body : {};
    const renderers = useRichTextRenderers({
        VideoComponent,
        QuestionComponent,
        CodeComponent,
        LabComponent,
        LinkComponent,
        ImageComponent
    });
    const renderRedraft = () => {
        try {
            return redraft(val, renderers, { cleanup: false });
        }
        catch (error) {
            console.error(error);
            return React.createElement("p", null, RICH_TEXT_ERROR_TEXT);
        }
    };
    if (type && type === DRAFTJS_V0) {
        return (React.createElement(ViewerErrorBoundary, null,
            React.createElement(Textiles, null, renderRedraft())));
    }
    return null;
};
export default RichTextViewer;
//# sourceMappingURL=index.js.map